const geoLoadBalancing ={
  'TITLE': 'Cân bằng tải địa lý',
  'EDIT': 'Sửa',
  'SAVE': 'Lưu',
  'CANCEL': 'Loại bỏ',
  'NOTE': 'Lưu ý: Khách hàng tiềm năng mới sẽ được phân bổ theo thiết lập tỷ lệ này',
  'ALERT': 'Giá trị nhập vào không được quá'
}

export default geoLoadBalancing;